"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const theme_1 = require("../../../../styles/theme");
const TGOptionLazyModalActions = (props) => {
    const { multiSelect, state, isNothingSelected, totalCount, handleClearAll, selectAllAssets } = props;
    const classes = useStyles();
    const numberOfElements = (0, react_1.useMemo)(() => {
        if (isNothingSelected) {
            return totalCount;
        }
        return state.length;
    }, [isNothingSelected, totalCount, state]);
    const button = (0, react_1.useMemo)(() => {
        if (multiSelect) {
            if (isNothingSelected) {
                return react_1.default.createElement(core_1.Button, { onClick: selectAllAssets }, "Select All");
            }
            else {
                return react_1.default.createElement(core_1.Button, { onClick: handleClearAll }, "Deselect All");
            }
        }
        else {
            return react_1.default.createElement(core_1.Button, { onClick: handleClearAll }, "Clear Selection");
        }
    }, [multiSelect, isNothingSelected, handleClearAll, selectAllAssets]);
    // Brackets are inside spans in order to center them vertically with the text (Roboto by default does not do that)
    if (multiSelect) {
        return (react_1.default.createElement("div", { className: classes.actionsContainer },
            button,
            react_1.default.createElement(core_1.Typography, { className: classes.numberOfElements },
                react_1.default.createElement("span", null, "("),
                numberOfElements,
                react_1.default.createElement("span", null, ")"))));
    }
    return button;
};
const useStyles = (0, core_1.makeStyles)(() => ({
    actionsContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    numberOfElements: {
        color: theme_1.colors.grayDescription,
        fontSize: 14,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& span': {
            height: 21.5,
        },
    },
}));
exports.default = TGOptionLazyModalActions;
//# sourceMappingURL=TGOptionLazyModalActions.js.map